import React, { useState, useRef, useEffect } from 'react';

const CustomDropdown = ({
  value,
  onChange,
  options,
  placeholder,
  disabled = false,
  className = '',
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [open]);

  const selected = options.find((opt) => opt.value === value);

  return (
    <div ref={containerRef} className={`relative ${className}`}>
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen((o) => !o)}
        className={`w-full p-3 sm:p-4 border-2 rounded-2xl text-base sm:text-lg flex items-center justify-between transition-colors text-left ${
          disabled
            ? 'border-gray-200 bg-gray-50 text-gray-400 cursor-not-allowed'
            : open
              ? 'border-indigo-500 bg-white'
              : 'border-gray-300 bg-white text-gray-800'
        }`}
        style={{ touchAction: 'manipulation' }}
      >
        <span className={`truncate ${!selected ? 'text-gray-400' : ''}`}>
          {selected ? selected.label : placeholder}
        </span>
        <svg
          className={`w-5 h-5 ml-2 flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && !disabled && (
        <ul
          className="absolute z-30 mt-1 w-full bg-white border-2 border-gray-200 rounded-2xl shadow-lg max-h-60 overflow-y-auto py-1"
          role="listbox"
        >
          {options.length === 0 ? (
            <li className="px-4 py-3 text-gray-400 text-base">—</li>
          ) : (
            options.map((opt) => (
              <li
                key={opt.value}
                role="option"
                aria-selected={opt.value === value}
                onClick={() => {
                  onChange(opt.value);
                  setOpen(false);
                }}
                className={`px-4 py-3 text-base sm:text-lg cursor-pointer transition-colors ${
                  opt.value === value
                    ? 'bg-indigo-500 text-white'
                    : 'text-gray-800 hover:bg-indigo-50 active:bg-indigo-100'
                }`}
                style={{ touchAction: 'manipulation' }}
              >
                {opt.label}
              </li>
            ))
          )}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
